import { DashboardOverview } from '@adminModels';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  adminStatsControllerGetEventStats,
  adminStatsControllerGetUserStats,
  adminStatsControllerGetVolunteerStats,
} from '@klubovna/api-client';
import { EventStatsDto, UserStatsDto, VolunteerStatsDto } from '@klubovna/api-client';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  getOverview(): Observable<DashboardOverview> {
    return of({
      metrics: [],
      lastUpdated: null,
    });
  }

  getUserStats(): Observable<UserStatsDto> {
    return adminStatsControllerGetUserStats(this.http, this.apiConfig.rootUrl)
      .pipe(
        map((response) => response.body ?? { byRole: [] }),
      );
  }

  getEventStats(): Observable<EventStatsDto> {
    return adminStatsControllerGetEventStats(this.http, this.apiConfig.rootUrl)
      .pipe(
        map((response) => response.body ?? { byStatus: [], byTag: [], withoutTag: 0 }),
      );
  }

  getVolunteerStats(): Observable<VolunteerStatsDto> {
    return adminStatsControllerGetVolunteerStats(this.http, this.apiConfig.rootUrl)
      .pipe(
        map((response) => response.body ?? {
          statuses: {
            approved: 0,
            adjustedApproved: 0,
            adjustedShare: 0,
            pending: 0,
            rejected: 0,
            criticalPending: 0,
            rejectionRate: 0,
          },
          workTypes: [],
          rewards: {
            summary: { count: 0, sumSpent: 0 },
            byIssuer: [],
            byRecipient: [],
            burnRate: 0,
          },
          leaderboard: [],
          balances: {
            buckets: { zero: 0, from1To50: 0, from51To100: 0, above100: 0 },
            zeroBalanceUsers: [],
          },
        }),
      );
  }
}
